export const daysOfTheWeek = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' },
];

export const timeOptions = [
  {
    startTime: '07:00',
    endTime: '15:00',
  },
  {
    startTime: '14:00',
    endTime: '22:00',
  },
  {
    startTime: '22:00',
    endTime: '08:00',
  },
  {
    startTime: '07:00',
    endTime: '22:00',
  },
];

export const dateFormat = 'DD/MM/YYYY';
export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;
export const longDateFormat = 'dddd DD of MMMM';
